<template>
  <Public header="forgot-password">
    <v-main>
      <v-container style="min-height: calc(100% - 140px)">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="6" class="mt-16 mb-16">
            <ForgotPassword :forgotNoLogin="true" />
          </v-col>
        </v-row>
      </v-container>
      <footer-web></footer-web>
    </v-main>
  </Public>
</template>

<script>
import Public from '@/components/public/public-main-template'
import FooterWeb from '@/components/public/footer'
import ForgotPassword from '@/components/admin/profile/form-forgot-password'

export default {
  name: 'Forgotpassword',
  components: {
    Public,
    FooterWeb,
    ForgotPassword
  },
//   data() {
//     return {
//       valid: false,
//       email: '',
//       password: '',
//       emailRules: [
//         v => !!v || 'E-mail is required',
//         v => /.+@.+/.test(v) || 'E-mail must be valid'
//       ],
//       passwordRules: [
//         v => !!v || 'Password is required',
//         v =>
//           v.length >= 6 ||
//           'Password must be greater than 6 characters'
//       ],
//       showPassword: false
//     }
//   },
//   methods: {
//     submit(e) {
//       e.preventDefault();
//       this.$store.dispatch('auth/login', {email: this.email, password: this.password})
//     }
//   }
}
</script>
